import script from "./AddSaleCategoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSaleCategoryModal.vue?vue&type=script&setup=true&lang=js"

import "./AddSaleCategoryModal.vue?vue&type=style&index=0&id=ec27a0f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec27a0f4"]])

export default __exports__